import * as _ from 'underscore'

import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { ColumnInfo, OpPackageStatusFlow } from "../models/custom"
import { OpPackage, OpPackageStatus } from "../models/core"

export class DataProviderPackage {

    //#region Consts

    private static get LOG_PREFIX(): string { return '[SIMAX.DataProvider.Package]' }

    //#endregion Consts End

    //#region Ctor

    constructor(private dataProvider: DataProvider) { }

    //#endregion End


    //#region Delete

    public deletePackage = (opObj: OpPackage): JQueryPromise<OpPackage> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSavePackage', { ToBeSaved: opObj.toJSON() }, 'OpxSavePackageResult')
            .then((response: any) => {
                if (response != null) {
                    const order: OpPackage = new OpPackage(response)

                    return OpPackage
                        .loadNavigationProperties(this.dataProvider, [order])
                        .then((order: OpPackage[]) => {
                            return _.first(order)
                        })
                }

                return null
            })
    }

    //#endregion


    //#region Get

    public findPackageBySerialNbr = (serialNbr: string): JQueryPromise<OpPackage[]> => {
        return this.dataProvider.sendRequestWithSession('OpxFindPackageBySerialNbr', { serialNbr: serialNbr }, 'OpxFindPackageBySerialNbrResult').then((response: any[]) => {
            return response.map(e => new OpPackage(e))
        })
    }

    public getPackage = (id: number): JQueryPromise<OpPackage> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetPackage', { IdPackage: id }, 'OpxGetPackageResult')
            .then((response: Object) => {
                if (response != null) {
                    const order: OpPackage = new OpPackage(response)

                    return OpPackage
                        .loadNavigationProperties(this.dataProvider, [order])
                        .then((order: OpPackage[]) => {
                            return _.first(order)
                        })
                }

                return null
            })
    }

    public getPackageFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpPackage>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdPackage, 'OpxPackageFilter', 'OpxPackageFilterResult')
    }

    //#endregion


    //#region Save

    public savePackage = (order: OpPackage): JQueryPromise<OpPackage> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSavePackage', { ToBeSaved: order.toJSON() }, 'OpxSavePackageResult')
            .then((response: any) => {
                if (response != null) {
                    const order: OpPackage = new OpPackage(response)

                    return OpPackage
                        .loadNavigationProperties(this.dataProvider, [order])
                        .then((order: OpPackage[]) => {
                            return _.first(order)
                        })
                }

                return null
            })
    }

    //#endregion


    //#region Status

    public getPackageStatusFlow = (): JQueryPromise<OpPackageStatusFlow[]> => {
        return this.dataProvider.System.getFlow<OpPackageStatusFlow>(Enums.DataType.HELPER_ID_PACKAGE_STATUS)
    }

    public getNextPackageStatuses = (packageStatus: Enums.PackageStatus): JQueryPromise<OpPackageStatus[]> => {
        return this.dataProvider.System.getFlowByStatus<OpPackageStatusFlow, OpPackageStatus>(Enums.DataType.HELPER_ID_PACKAGE_STATUS, (status: OpPackageStatusFlow) => status.packageStatus.idPackageStatus === packageStatus)
    }


    /**
     * Handles Package and orders statuses
     */
    public getNextCombinedPackageStatuses = (packageStatus: Enums.PackageStatus): JQueryPromise<OpPackageStatus[]> => {
        return this.getNextPackageStatuses(packageStatus)
            .then((packageStatuses: OpPackageStatus[]) => {
                if (_.size(packageStatuses) > 0) {
                    return packageStatuses
                }

                return this.dataProvider.Order.getNextOrderStatuses(packageStatus)
            })
    }

    //#endregion
}